module.exports = "/images/pin-performance.png?6669ab0588c5809caa2cc93871d891bf";